// extracted by mini-css-extract-plugin
export default {"label":"BottomSheetLabel_label__qsWOY"};